/**
 * Port of app_router.dart:68-70 — an unauthenticated user hitting anything that
 * is not `/auth/*`, `/public/*`, or the landing page is sent to `/auth/login`.
 *
 * Here it is a route-tree wrapper rather than a global redirect callback: the
 * public and auth branches simply do not wrap themselves in it, which makes the
 * "except these" list structural instead of a string-prefix test that has to be
 * kept in sync with the route table.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { ROUTES } from '../paths';

export function RequireAuth(): React.JSX.Element {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // `state.from` lets the login page return the user to where they were
    // headed. GoRouter drops this; keeping it is free here and is the behaviour
    // a web user expects from a bookmarked deep link.
    return <Navigate to={ROUTES.login} state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export default RequireAuth;
